import { render, staticRenderFns } from "./LoremIpsum.vue?vue&type=template&id=427ab678&scoped=true&"
import script from "./LoremIpsum.vue?vue&type=script&lang=js&"
export * from "./LoremIpsum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427ab678",
  null
  
)

export default component.exports